export enum SizeProp {
  Small = 'small',
  Medium = 'medium',
}
